import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Table,
  Alert,
  Label,
  Input,
} from "reactstrap";
import style from "./styles.module.scss";
import { Status, FormSelect, FormNumber } from "../Controls";
import LaddaButton, { SLIDE_LEFT } from "react-ladda";
import { AssetStatus } from "../types";
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput";
import { toFormatDate } from "../../../utils";

const ModalStatus = ({ open, toggle, item, changeStatus, getContractcLosingLeg }) => {
  const [alert, setAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nextStatus, setNextStatus] = useState(item.AssetStatus);
  const [contractClosingLeg, setContractClosingLeg] = useState();
  const [alreadyLoaded, setAlreadyLoaded] = useState(false);
  const [alreadyConfirmed, setAlreadyConfirmed] = useState(false);
  const [contractClosingLegModified, setContractClosingLegModified] = useState(false);
  const [showClosingLeg, setShowClosingLeg] = useState(false);
  const initialDate = toFormatDate(new Date());
  const [maturityDate, setMaturityDate] = useState();

  useEffect(() => {
    if (open) {
      setAlert(false);
      setLoading(false);
      getClosingLeg();
      setMaturityDate(initialDate);
    }
  }, [open]);

  const getClosingLeg = () => {
    if (!alreadyLoaded) {
      setAlreadyLoaded(true);
      getContractcLosingLeg(item.AssetId).then((res) => {
        if (res) {
          res.ContractClosingLeg != 0
            ? (setContractClosingLeg(res.ContractClosingLeg), setShowClosingLeg(true))
            : (setContractClosingLeg(0), setShowClosingLeg(false));
        }
      });
    }
  };

  const handleChangeStatus = () => {
    if (nextStatus == "Matured" && contractClosingLegModified) {
      let confirmation = confirm("Are you sure you want to change the closing value?");
      if (confirmation) {
        confirmChangeStatus(contractClosingLeg);
      }
    } else {
      setLoading(true);
      setAlert(false);
      confirmChangeStatus();
    }
  };

  const confirmChangeStatus = (closingLeg) => {
    changeStatus({
      assetId: item.AssetId,
      nextStatus,
      closingleg: closingLeg,
      maturityDate: maturityDate,
    })
      .then((res) => res.result)
      .then((result) => {
        setLoading(false);
        if (result.Code == 200) {
          toggle();
        } else {
          setAlert(result.Description);
        }
      });
  };

  const quantityOnClick = (e) => {
    setContractClosingLegModified(true);
    e != "" ? setContractClosingLeg(e.target.value) : "";
  };

  const dateOnClick = (e) => {
    setMaturityDate(e);
  };

  return (
    <Modal isOpen={open} toggle={toggle} className={style.modal}>
      <ModalHeader toggle={toggle}>Change asset status</ModalHeader>
      <ModalBody className={style.body}>
        <Container className={style.container}>
          <Row>
            <Col lg="7">
              <span className="d-block text-truncate">{item.AssetTicker}</span>
            </Col>
            <Col lg="5 text-center">
              <span className="d-block mb-1">Current status</span>
              <Status status={item.AssetStatus} />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col lg="12">
              <FormSelect
                name="NextStatus"
                label="Next status"
                selectItems={AssetStatusValues}
                getSelectItemId={(i) => i.id}
                getSelectItemName={(i) => i.description}
                value={nextStatus}
                onChange={(name, value) => {
                  setNextStatus(value), setAlreadyLoaded(false), setAlreadyConfirmed(false);
                }}
              />
              {showClosingLeg && nextStatus == "Matured" && (
                <div>
                  <Label for="closingLeg">Closing leg</Label>
                  <NumberFormatInput
                    id="closingLeg"
                    type="text"
                    customInput={Input}
                    name="closingLeg"
                    placeholder="Quantity"
                    value={contractClosingLeg}
                    onValueChange={({ value }) => {
                      setContractClosingLegModified(true);
                      setContractClosingLeg(value);
                    }}
                    dataTypeDecimalName="quantity"
                  />
                </div>
              )}
              {nextStatus == "Matured" && item.AssetStatus != "Matured" && (
                <div>
                  <Label for="maturedDate">Matured date</Label>
                  <Input
                    id="maturedDate"
                    type="date"
                    name="maturedDate"
                    placeholder="Matured date"
                    value={maturityDate}
                    onChange={(e) => {
                      dateOnClick(e.target.value);
                    }}
                  />
                </div>
              )}
              {""}
              {alert && (
                <Alert color="danger" className="p-2">
                  {alert.split(".").map((line, index) => (
                    <span key={`line-${index}`} className="d-block">
                      {line}.
                    </span>
                  ))}
                </Alert>
              )}
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle}>
          Close
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={loading}
          disabled={nextStatus === item.AssetStatus}
          onClick={handleChangeStatus}
          data-style={SLIDE_LEFT}
        >
          Change Status
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

const AssetStatusValues = Object.entries(AssetStatus).map(([key, value]) => ({
  id: key,
  description: value,
}));

export default ModalStatus;
